import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, 
  faGraduationCap, 
  faUsers, 
  faHandshake,
  faFileAlt,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const StellenangebotePage: React.FC = () => {
  // Sample job offerings
  const jobs = [
    {
      title: 'Elektroingenieur/Techniker/Meister (m/w/d)',
      description: 'Für die Planung von elektrotechnischen Anlagen in Gebäuden suchen wir eine/n Elektroingenieur/in, Techniker/in oder Meister/in.',
      requirements: [
        'Abgeschlossenes Studium der Elektrotechnik oder Techniker-/Meisterausbildung',
        'Mehrjährige Berufserfahrung in der Gebäudetechnikplanung',
        'Kenntnisse in CAD und BIM',
        'Selbstständige und strukturierte Arbeitsweise'
      ],
      location: 'Rain am Lech'
    },
    {
      title: 'Systemplaner/in Elektrotechnik (m/w/d)',
      description: 'Zur Verstärkung unseres Teams suchen wir eine/n Systemplaner/in Elektrotechnik für die Erstellung von Ausführungs- und Planungsunterlagen.',
      requirements: [
        'Abgeschlossene Ausbildung als Technische/r Systemplaner/in Elektrotechnik oder vergleichbare Qualifikation',
        'Sicherer Umgang mit CAD-Software',
        'Kenntnisse im Bereich Elektrotechnik von Vorteil',
        'Teamfähigkeit und Zuverlässigkeit'
      ],
      location: 'Rain am Lech'
    },
    {
      title: 'Werkstudent/in (m/w/d)',
      description: 'Für die Unterstützung bei Planungsprojekten suchen wir engagierte Werkstudenten im Bereich Elektrotechnik oder Architektur.',
      requirements: [
        'Laufendes Studium im Bereich Elektrotechnik, Architektur oder vergleichbar',
        'Grundkenntnisse in CAD',
        'Interesse an der Gebäudetechnikplanung',
        'Flexibilität und Lernbereitschaft'
      ],
      location: 'Rain am Lech oder Marxheim'
    },
    {
      title: 'HLS Ingenieur/Techniker/Meister (m/w/d)',
      description: 'Zur Erweiterung unseres Teams suchen wir einen erfahrenen HLS-Spezialisten für die Planung von Heizungs-, Lüftungs- und Sanitäranlagen.',
      requirements: [
        'Abgeschlossenes Studium der Versorgungstechnik, Techniker- oder Meisterausbildung im HLS-Bereich',
        'Mehrjährige Berufserfahrung in der HLS-Planung',
        'Sicherer Umgang mit CAD-Software und HLS-Planungstools',
        'Kenntnisse in Energieeffizienz und nachhaltiger Gebäudetechnik',
        'Teamfähigkeit und selbstständige Arbeitsweise'
      ],
      location: 'Rain am Lech'
    }
  ];

  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <h1>Stellenangebote</h1>
            <p>
              Werden Sie Teil unseres Teams und gestalten Sie mit uns die Zukunft der Gebäudetechnik
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Karriere bei IB Neubaur</h2>
            <p>
              Das Ingenieurbüro Neubaur ist ein innovatives Unternehmen im Bereich der Elektro- und Gebäudetechnikplanung. 
              Wir bieten unseren Mitarbeitern ein spannendes Arbeitsumfeld mit vielfältigen Projekten und 
              Entwicklungsmöglichkeiten.
            </p>
            <p>
              Wir legen großen Wert auf ein kollegiales Miteinander, flache Hierarchien und eine offene Kommunikation. 
              Bei uns haben Sie die Möglichkeit, Ihre Fähigkeiten und Ideen einzubringen und aktiv an der Gestaltung 
              unserer Projekte mitzuwirken.
            </p>
          </section>

          {/* Benefits Section */}
          <section className="service-section">
            <h2 className="service-section-title">Das bieten wir Ihnen</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faGraduationCap} />
                </div>
                <h3 className="service-feature-title">Weiterbildung</h3>
                <p className="service-feature-text">
                  Regelmäßige Weiterbildungsmöglichkeiten und Unterstützung bei der beruflichen Entwicklung.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faUsers} />
                </div>
                <h3 className="service-feature-title">Teamarbeit</h3>
                <p className="service-feature-text">
                  Kollegiales Arbeitsumfeld mit flachen Hierarchien und offener Kommunikation.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faHandshake} />
                </div>
                <h3 className="service-feature-title">Flexible Arbeitszeiten</h3>
                <p className="service-feature-text">
                  Flexible Arbeitszeitmodelle für eine optimale Work-Life-Balance.
                </p>
              </div>
            </div>
          </section>

          {/* Job Offerings Section */}
          <section className="service-section">
            <h2 className="service-section-title">Aktuelle Stellenangebote</h2>
            
            {jobs.map((job, index) => (
              <div key={index} className="service-cta" style={{ marginBottom: '2rem', textAlign: 'left' }}>
                <h3 className="service-cta-title">{job.title}</h3>
                <p><strong>Standort:</strong> {job.location}</p>
                <p>{job.description}</p>
                
                <h4 style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>Anforderungen:</h4>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  {job.requirements.map((req, i) => (
                    <li key={i}>{req}</li>
                  ))}
                </ul>
                
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Link to="/kontakt" className="btn btn-primary">
                    <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '0.5rem' }} /> Jetzt bewerben
                  </Link>
                </div>
              </div>
            ))}
          </section>

          {/* Speculative Application Section */}
          <section className="service-section">
            <h2 className="service-section-title">Initiativbewerbung</h2>
            <p>
              Sie haben kein passendes Stellenangebot gefunden, möchten aber dennoch Teil unseres Teams werden? 
              Wir freuen uns auch über Ihre Initiativbewerbung!
            </p>
            
            <div className="service-cta" style={{ marginTop: '2rem' }}>
              <h3 className="service-cta-title">Ihre Bewerbungsunterlagen</h3>
              <p className="service-cta-text">
                Senden Sie uns Ihre vollständigen Bewerbungsunterlagen (Anschreiben, Lebenslauf, Zeugnisse) 
                per E-Mail oder nutzen Sie unser Kontaktformular. Wir freuen uns darauf, Sie kennenzulernen!
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                <a href="mailto:info@neubaur-gmbh.de" className="btn btn-primary">
                  <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '0.5rem' }} /> E-Mail
                </a>
                <Link to="/kontakt" className="btn btn-outline">
                  <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '0.5rem' }} /> Kontaktformular
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default StellenangebotePage;
